module.exports = __webpack_public_path__ + "img/certificate.d2a401fa.png";